import React, { useEffect } from 'react';
import QuoteDetailTabsListing from "./QuoteDetail/QuoteDetailTabsListing";
import useReduxState from "../hooks/useReduxState";
import { CustomerInformation } from "./QuoteDetail/Component/CustomerInformation";
import { useQuoteDetailStore } from "../hooks/quote-detail";
import keylegendIcon from 'src/assets/images/key.svg'
import infoIcon from 'src/assets/images/info.svg'
import opencreateIcon from 'src/assets/images/open_create.svg'
import Helper from 'src/support/Helper';
import { Tooltip } from 'src/component/Tooltip';
import System from 'src/helper/system';
import Quote from "@system/config/quote";
import SystemAlerts from 'src/component/SystemAlerts';

export default function QuoteDetail(props) {
    const [selectedTab] = useReduxState('', 'searchParams')
    const [{ quoteNumber }, { }, { destroy_cart_quote_active_session }] = useQuoteDetailStore();
    const c = System.getParams();
    const quoteProvisionalNumber = c.quoteProvisionalNumber;
    const status = c.__c_QuoteDetailTabList;

    const renderKeyLegendTooltip = () => {
        return (
            <>
                <b>Offline:</b> Quotes created in the Avnet {System.avUserInfoData.speedBoatName} <br />
                Internal Quote Tool <br />
                <b>Online:</b> Quotes created in {Helper.getHCLDXBaseUrlHost()}
            </>
        )
    }
    const renderInformationTooltip = () => {
        return (
            <> Parts with no hyper link are not available to purchase or requote.</>
        )
    }
    useEffect(() => {
        destroy_cart_quote_active_session();
    }, []);
    return (

        <>
            <div className="container">
                <div
                    className="pcn-page-head header-container d-flex align-items-center justify-content-between">
                    <div className="page-title font-oswald font-light font-30">
                        {status === 'PND' ? <>Web Quote# {quoteProvisionalNumber}</> : <>Quote# {quoteNumber}</>}
                    </div>
                    <div className="ms-auto">
                        <ul className="list-inline mb-0">
                            <li>
                                <Tooltip
                                    position={'bottom left'}
                                    opener={() => (
                                        <a className="customer-link" href={void (0)}><i><img className="" src={keylegendIcon} alt='Key/Legend' /></i><span
                                            className="bs5 text-blue">Key/Legend</span></a>
                                    )}
                                    content={() => (
                                        renderKeyLegendTooltip()
                                    )}
                                />
                            </li>
                            <li>
                                <Tooltip
                                    position={'bottom left'}
                                    opener={() => (
                                        <a className="customer-link" href={void (0)}><i><img src={infoIcon} alt='Information' /></i><span
                                            className="bs5 text-blue">Information</span></a>
                                    )}
                                    content={() => (
                                        renderInformationTooltip()
                                    )}
                                />
                            </li>
                            <li><a className="customer-link" href={Quote.getQuoteRouteURL()}>
                                <i><img src={opencreateIcon} alt='Open/Create Quote' /></i>
                                <span className="bs5 text-blue">Open/Create Quote</span>
                            </a></li>
                        </ul>
                    </div>
                </div>
                <div className='mt-2'>
                    <SystemAlerts />
                </div>
                <CustomerInformation quoteNumber={quoteNumber} />
            </div>
            <div id="submitted-pcnquote-page" className="pcn-page container mt-3">
                <div className="customer-info">
                    <div className="logged-screen">
                        <QuoteDetailTabsListing selectedTab={selectedTab} {...props} />
                    </div>
                </div>
            </div>
        </>

    );
}